import { Link } from 'react-router-dom';

const accountDeletionSections = [
  {
    title: 'How to Request Account Deletion',
    body: 'Send your deletion request to me@kalamanch.art from your registered email ID with subject: "Account Deletion Request". Please include your role (artist or collaborator), registered email, and account name so we can verify and process safely.',
  },
  {
    title: 'Alternative Support Channel',
    body: 'You can also submit a deletion request using the support option available on Kalamanch.art. For security, we may ask for identity confirmation before deleting an account.',
  },
  {
    title: 'What Data Is Deleted',
    body: 'After successful verification, we delete or anonymize your account profile data and public-facing profile information, including bio, profile details, uploaded profile media links, notification tokens, and account access related to the deleted account where deletion is technically and legally possible.',
  },
  {
    title: 'What May Be Retained',
    body: 'Certain records may be retained for legal, fraud-prevention, abuse-handling, child safety, security, financial audit, platform integrity, or dispute-resolution purposes. This may include system logs, moderation records, AI safety logs, project/audition workflow records, support messages, and message metadata where legally required.',
  },
  {
    title: 'Retention Period',
    body: 'Most account deletion requests are processed within 7 to 15 business days. Backup systems may retain limited data for up to 90 days before automatic purge, unless a longer retention period is required by law.',
  },
  {
    title: 'Messages and Conversations',
    body: 'If a user deletes an account, past PMB/enquiry conversation records already received by other users may remain visible in those users\' inbox history for continuity, safety, and compliance, unless removal is legally required.',
  },
  {
    title: 'Projects, Auditions, and Competitions',
    body: 'Project responses, audition invitations, competition participation, and selected/public participant records may be deleted, anonymized, or retained depending on legal, safety, admin review, and dispute-handling requirements.',
  },
];

const AccountDeletion = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-purple-50 pt-24" data-testid="account-deletion-page">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
          <p className="text-sm font-bold uppercase tracking-[0.3em] text-[#FF6F00] mb-4">Google Play compliance</p>
          <h1 className="text-4xl sm:text-5xl font-bold gradient-text mb-6">Account Deletion</h1>
          <p className="text-gray-600 mb-8">Effective date: May 17, 2026</p>

          <div className="rounded-2xl bg-orange-50 p-5 text-gray-700 leading-7 mb-10">
            Kalamanch.art is owned and operated by Tivaro LLP. This page explains how Kalamanch.art users can
            request account deletion and how account-related data is handled after a deletion request.
          </div>

          <div className="space-y-8 text-gray-700 leading-8">
            {accountDeletionSections.map((section) => (
              <section key={section.title}>
                <h2 className="text-2xl font-bold text-gray-900 mb-3">{section.title}</h2>
                <p>{section.body}</p>
              </section>
            ))}

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">Contact for Deletion Requests</h2>
              <p>
                Email: <span className="font-semibold">me@kalamanch.art</span>
              </p>
            </section>
          </div>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <Link to="/privacy-policy" className="btn-primary text-center">
              Read Privacy Policy
            </Link>
            <Link to="/contact" className="btn-outline text-center">
              Contact Support
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountDeletion;
